import { SET_DEVICE_FROM_CUSTOMER_DETAILS } from './index';
import fetchDevices from './fetch-devices';
import selectDeviceModel from './select-device-model';

export default function setDeviceFromCustomerDetails(groupSlug) {
  return async (dispatch, getState) => {
    dispatch({ type: SET_DEVICE_FROM_CUSTOMER_DETAILS });
    const {
      selectedDevices: { model },
      contact,
    } = getState();

    if (!model?.id) {
      return;
    }

    dispatch(fetchDevices(groupSlug)).then(() => {
      const {
        devices: { devicesById },
      } = getState();
      const device = devicesById[model.id];
      if (device) {
        dispatch(selectDeviceModel(device, contact.phoneNumber));
      }
    });
  };
}
